import { createSelector } from 'reselect';
import RfidOnRouteReportColumns from '../../containers/RfidOnRouteReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_RFID_ON_ROUTE.isLoading;
export const getData = TableDefinitions.REPORTING_RFID_ON_ROUTE.getDataFunction();
export const getColumns = createSelector(getData, RfidOnRouteReportColumns);
